import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TravelOrderTable from "../TravelOrder/TravelOrderTable";
import { TableContainer } from '../Reusable/TableContainer';
import ModalForAddTravelOrder from '../TravelOrder/ModalForAddTravelOrder';
import { createTravelOrder, deleteErrorTravelOrder, deleteTravelOrder, findAllTravelOrderPageble, updateTravelOrder } from '../../actions/travelOrder';


const TravelOrderList = () => {
    const dispatch = useDispatch();
    //   const vehicleReducer = useSelector((state) => state.vehicle);
    const travelOrderReducer = useSelector((state) => state.travelOrder);
    const userReducer = useSelector((state) => state.user);
    // const vehicleModelReducer= useSelector((state) => state.vehicleModel)
    const [show, setShow] = useState(false);
    const [municipalities, setMunicipalities] = useState([]);

    useEffect(() => {
        fetch('/api/municipalities/findAll')
            .then(res => res.json())
            .then(data => setMunicipalities(data))
            .catch(err => console.error(err));
    }, []);

    const showModal = () => {
        setShow(true);
    };

    const clearValidationErrors = () => {
        dispatch(deleteErrorTravelOrder());
    };

    const handlePreviewClose = () => {
        setShow(false);
        clearValidationErrors();
    };

    const handleAdd = (travelOrder) => {
        dispatch(createTravelOrder(travelOrder, handlePreviewClose));
    };

    useEffect(() => {
        dispatch(findAllTravelOrderPageble((0, 8, [])));
    }, [dispatch, findAllTravelOrderPageble]);

    return (
        <>
            <TableContainer
                cardTitle={"Putni nalog"}
                showModal={showModal}
            >
                <TravelOrderTable
                municipalities={municipalities}
                    dispatch={dispatch}
                    travelOrderReducer={travelOrderReducer}
                    findAllTravelOrderPageble={findAllTravelOrderPageble}
                    updateTravelOrder={updateTravelOrder}
                    deleteTravelOrder={deleteTravelOrder}
                    clearValidationErrors={clearValidationErrors}
                />
            </TableContainer>
            {show && (
                <ModalForAddTravelOrder
                    municipalities={municipalities}
                    travelOrderReducer={travelOrderReducer}
                    handleAdd={handleAdd}
                    handleClose={handlePreviewClose}
                    show={show}
                    userReducer={userReducer}
                />
            )}
        </>
    );
};

export default TravelOrderList;
